import React from "react";
export const ShopPropsContext = React.createContext({});